module.exports = __webpack_public_path__ + "static/img/director_01.ff86f3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2022/corona/director_01.png
// module id = 4Ucl
// module chunks = 0